export class UrlParser {
  constructor () {
    const hash = window.location.hash.substring(1)
    this.parsedHash = new URLSearchParams(hash);
  }

  param (name) {
    return this.parsedHash.get(name)
  }
}
